import { hasPermissions, hasRole } from '~/utils/helpers';

export const sidebarElementAccess = (permissions: string[], roles: string[]): boolean => {
  if (permissions.length && !hasPermissions(permissions)) return false;
  if (roles.length && !hasRole(roles)) return false;
  return true;
};
